export default class CompanyData {
  constructor() {
    this.contacts = {
      added: {},
      changed: {},
      removed: {},
    };
    this.offices = {
      added: {},
      changed: {},
      removed: {},
    };
  }
  cleanData() {
    let cleanData = {
      contacts: {},
      offices: {},
    };
    let newContact = false;
    let newOffice = false;

    Object.keys(this.contacts).map((key) => {
      if (Object.keys(this.contacts[key]).length !== 0) {
        newContact = true;
        cleanData['contacts'][key] = this.contacts[key];
      }
    });
    
    Object.keys(this.offices).map((key) => {
      if (Object.keys(this.offices[key]).length !== 0) {
        newOffice = true;
        cleanData['offices'][key] = this.offices[key];
      }
    });

    if (!newContact) {
      delete cleanData['contacts'];
    }
    if (!newOffice) {
      delete cleanData['offices'];
    }
    return cleanData;
  }
}



// WEBPACK FOOTER //
// ./src/CompanyData.js